<template>
  <v-stepper
    v-if="profile"
    v-model="activeStep"
  >
    <StepperHeader
      :steps="steps"
      :active="activeStep"
      :is-profile-complete="isProfileComplete"
    />
    <StepperContent
      :active="activeStep"
      :steps="steps"
      :is-profile-complete="isProfileComplete"
      :change-step="changeActiveStep"
    />
  </v-stepper>
</template>

<script>
import { mapState } from 'vuex'
import { PROFILE_KEY } from '../../store/types/profile.types'
import StepperHeader from './StepperHeader'
import StepperContent from './StepperContent'

export default {
  name: 'VisitStepper',
  components: {
    StepperHeader,
    StepperContent,
  },
  data() {
    return {
      activeStep: 1,
      steps: [
        {
          label: this.$t('visits.stepper.firstStep'),
          completed: false,
          required: false,
        },
        {
          label: this.$t('visits.stepper.secondStep'),
          completed: false,
          required: true,
        },
        {
          label: this.$t('visits.stepper.thirdStep'),
          completed: false,
          required: true,
        },
      ],
    }
  },
  computed: {
    isProfileComplete() {
      return !Object.values(this.profile).some(value => this.isEmpty(value))
    },
    ...mapState({
      profile: state => state.profile[PROFILE_KEY],
    }),
  },
  methods: {
    isEmpty(value) {
      return typeof value === 'string' && value === ''
    },
    changeActiveStep(step = 1) {
      this.activeStep = step
    },
  },
}
</script>

<style lang="stylus" scoped>

</style>
